<template>
  <div class="section">
    <div class="section-header">
      <span class="section-number">四</span>
      <span class="section-text">底座共建进展</span>
    </div>
    <div class="base-build-container">
      <table class="base-build-table">
        <thead>
          <tr>
            <th>伙伴</th>
            <th style="width: 70px;">投入人数</th>
            <th>主要方向</th>
            <th>技能领域</th>
            <th style="width: 80px;">持续周期</th>
            <th style="width: 70px;">进度比例</th>
            <th class="base-build-jul" style="width: 160px;">7月</th>
            <th style="width: 1px;">8月</th>
            <th style="width: 80px;"></th>
            <th style="width: 1px;">9月</th>
            <th style="width: 80px;"></th>
            <th style="width: 1px;">10月</th>
            <th style="width: 80px;"></th>
            <th style="width: 1px;">11月</th>
            <th style="width: 80px;"></th>
            <th class="base-build-last-month" style="width: 1px;">12月</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in baseBuildData" :key="row.id">
            <td class="base-build-partner">{{ row.partner }}</td>
            <td>{{ row.people }}</td>
            <td>{{ row.direction }}</td>
            <td>{{ row.skills }}</td>
            <td>{{ row.period }}</td>
            <td>{{ row.progress }}</td>
            <td class="base-build-data-cell base-build-jul-cell">
              <div class="base-build-tag-wrapper">
                <span v-if="row.jun" :class="'base-build-tag ' + row.junClass">{{ row.jun }}</span>
                <span v-else class="base-build-tag-placeholder"></span>
                <span v-if="row.jul" :class="'base-build-tag ' + row.julClass">{{ row.jul }}</span>
                <span v-else class="base-build-tag-placeholder"></span>
              </div>
            </td>
            <td></td>
            <td class="base-build-data-cell"></td>
            <td></td>
            <td class="base-build-data-cell"></td>
            <td></td>
            <td class="base-build-data-cell"></td>
            <td></td>
            <td class="base-build-data-cell"></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="section-summary">
      <div class="section-summary-title">
        <span class="section-summary-icon"><build-outlined /></span>
        底座共建进展总结
      </div>
      <p>现有 11 家伙伴参与底座共建，总投入人力超 110 人，项目集中处于需求认领初期。深开鸿、鸿湖万联等头部伙伴投入人力最多；共建重点集中在分布式、AI、ArkUI、安全，同时覆盖交通、工业垂直场景。</p>
    </div>
  </div>
</template>

<script setup>
import { BuildOutlined } from '@ant-design/icons-vue';
const baseBuildData = [
  { id: 1, partner: '深开鸿', people: '20人', direction: '泛短距(5)+AI(5)+TOB(6)+分布式(4)', skills: 'C/C++, ArkTS, Agent', period: '1年', progress: '15%', jun: '需求沟通', junClass: 'tag-blue', jul: '需求认领', julClass: 'tag-blue' },
  { id: 2, partner: '开鸿智谷', people: '19人', direction: 'ArkUI(8)+AI(2)+生态共建(6)+前沿(2)+L0/L1(1)', skills: 'ArkTS, AI Agent', period: '0.7-1年', progress: '10%', jun: '需求沟通', junClass: 'tag-blue', jul: '', julClass: '' },
  { id: 3, partner: '润开鸿', people: '~15人', direction: 'TOB安全/软总线/性能/AI/OTA/UI', skills: 'C/C++, ArkTS, 安全, AI', period: '1年', progress: '10%', jun: '需求沟通', junClass: 'tag-blue', jul: '', julClass: '' },
  { id: 4, partner: '佳开鸿', people: '~8人', direction: '交通行业全栈(内核/安全/DFX/驱动/AI)', skills: '全栈', period: '0.7-1年', progress: '15%', jun: '需求沟通', junClass: 'tag-blue', jul: '需求认领', julClass: 'tag-blue' },
  { id: 5, partner: '诚迈', people: '6人', direction: '工业协议(1)+监控(1)+星闪(1)+软总线(2)', skills: 'C/C++, NAPI', period: '0.3-0.5年', progress: '15%', jun: '需求沟通', junClass: 'tag-blue', jul: '需求认领', julClass: 'tag-blue' },
  { id: 6, partner: '汇思博', people: '3人', direction: '安全/算法/证书密钥', skills: 'C/C++, ArkTS, 安全', period: '1年', progress: '15%', jun: '需求沟通', junClass: 'tag-blue', jul: '需求认领', julClass: 'tag-blue' },
  { id: 7, partner: '证通', people: '4人', direction: '资源监控(2)+文档阅读器(2)', skills: 'C++, JS/ArkUI', period: '1年', progress: '10%', jun: '需求沟通', junClass: 'tag-blue', jul: '', julClass: '' },
  { id: 8, partner: '中科鸿略', people: '2人', direction: '跨设备分布式投屏与互控', skills: 'C/C++, ArkTS', period: '1年', progress: '15%', jun: '需求沟通', junClass: 'tag-blue', jul: '需求认领', julClass: 'tag-blue' },
  { id: 9, partner: '国开鸿', people: '3人', direction: '应用生态(1)+DFX(1)+软总线(1)', skills: 'C/C++, ArkTS', period: '1年', progress: '15%', jun: '需求沟通', junClass: 'tag-blue', jul: '需求认领', julClass: 'tag-blue' },
  { id: 10, partner: '东软', people: '10人', direction: 'ArkUI(3)+ArkWeb(3)+多媒体(2)+AI(2)', skills: 'C/C++, ArkTS, Web', period: '1年', progress: '10%', jun: '需求沟通', junClass: 'tag-blue', jul: '', julClass: '' },
  { id: 11, partner: '鸿湖万联', people: '20人', direction: 'ArkUI代码冲量', skills: 'C/C++, ArkTS', period: '1年', progress: '15%', jun: '需求沟通', junClass: 'tag-blue', jul: '需求认领', julClass: 'tag-blue' }
];
</script>

<style scoped>
.section { margin-bottom: 32px; }
.section-header { display: flex; align-items: center; gap: 14px; margin-bottom: 20px; padding-bottom: 12px; border-bottom: 2px solid #f0f0f0; }
.section-number { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 8px; background: linear-gradient(135deg, #50A2FF 0%, #3B82F6 100%); color: #fff; font-size: 15px; font-weight: 700; flex-shrink: 0; box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3); }
.section-text { font-size: 18px; font-weight: 700; color: #1a1a2e; letter-spacing: 0.5px; }

.base-build-container { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px 24px; overflow-x: auto; }
.base-build-table { width: 100%; border-collapse: collapse; font-size: 13px; min-width: 900px; }
.base-build-table th { background: #f9fafb; padding: 10px 4px; text-align: center; font-weight: 600; color: #374151; border-bottom: 2px solid #e5e7eb; white-space: nowrap; }
.base-build-table th:empty { padding: 10px 2px; min-width: 60px; }
.base-build-table td { padding: 10px 12px; border-bottom: 1px solid #f3f4f6; color: #4b5563; vertical-align: middle; text-align: center; }
.base-build-table tbody tr:nth-child(even) { background: #f8f9fb; }
.base-build-partner { font-weight: 600; color: #1a1a2e; white-space: nowrap; }
.base-build-data-cell { position: relative; padding: 0 !important; overflow: visible; width: 80px; }
.base-build-data-cell .base-build-tag { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); white-space: nowrap; z-index: 1; }
.base-build-jul-cell { width: 160px !important; padding: 10px 8px !important; position: static !important; }
.base-build-jul-cell .base-build-tag-wrapper { display: flex; align-items: center; justify-content: center; gap: 8px; white-space: nowrap; }
.base-build-jul-cell .base-build-tag { position: static !important; transform: none !important; }
.base-build-tag-placeholder { display: inline-block; padding: 3px 10px; border-radius: 4px; font-size: 12px; font-weight: 500; visibility: hidden; }
.base-build-tag-placeholder::after { content: '需求沟通'; }
.base-build-tag-sep { width: 8px; display: inline-block; }
.base-build-tag { display: inline-block; padding: 3px 10px; border-radius: 4px; font-size: 12px; font-weight: 500; white-space: nowrap; }
.tag-blue { background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; }
.base-build-last-month { padding: 10px 16px 10px 4px !important; }

.section-summary { background: linear-gradient(135deg, #f0f7ff 0%, #f5f3ff 100%); border: 1px solid #c7d2fe; border-left: 4px solid #3b82f6; border-radius: 8px; padding: 20px 24px; margin-top: 16px; text-align: left; }
.section-summary-title { display: flex; align-items: center; gap: 8px; font-size: 16px; font-weight: 700; color: #1e3a5f; margin-bottom: 12px; }
.section-summary-icon { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 6px; background: linear-gradient(135deg, #3b82f6, #6366f1); color: #fff; font-size: 14px; font-weight: 700; }
.section-summary p { font-size: 14px; line-height: 1.8; color: #374151; margin: 0; }
</style>
